"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStatsigInternalClientFactoryAsync = void 0;
const react_1 = require("react");
const client_core_1 = require("@statsig/client-core");
function useStatsigInternalClientFactoryAsync(factory, args) {
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const clientRef = (0, react_1.useRef)((0, client_core_1._getInstance)(args.sdkKey));
    const client = (0, react_1.useMemo)(() => {
        if (clientRef.current) {
            return clientRef.current;
        }
        const inst = factory(args);
        clientRef.current = inst;
        inst
            .initializeAsync()
            .catch(client_core_1.Log.error)
            .finally(() => setIsLoading(false));
        return inst;
    }, []);
    return { client, isLoading };
}
exports.useStatsigInternalClientFactoryAsync = useStatsigInternalClientFactoryAsync;
